module.exports = __webpack_public_path__ + "static/memsource-copy-client-id-864765321d33ebb851736e550213f317.jpg";